import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Artist } from "types/artist";

export const useArtists = () => {
  const [artists, setArtists] = React.useState<Artist[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => await getArtists())();
  }, []);

  const getArtists = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Artists}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setArtists(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  return { artists, fetching };
};
